// extracted by mini-css-extract-plugin
export default {"container":"separatorSection_container__lWqVz","dot":"separatorSection_dot__H7Vm+","star":"separatorSection_star__YpOTi","moving":"separatorSection_moving__MItVU"};